import { Lightbulb } from "lucide-react";

// Permanent "Innovator" emblem — awarded when a student's feature request ships.
export function InnovatorBadge({ compact = false, className = "" }) {
  if (compact) {
    return (
      <span
        title="Innovator — your idea shipped"
        aria-label="Innovator"
        data-testid="innovator-badge"
        className={`inline-flex items-center justify-center rounded-full bg-gradient-to-br from-emerald-300 to-teal-500 text-emerald-950 w-5 h-5 shadow-sm shrink-0 ${className}`}
      >
        <Lightbulb size={12} strokeWidth={2.2} />
      </span>
    );
  }
  return (
    <span
      data-testid="innovator-badge"
      className={`inline-flex items-center gap-1.5 rounded-full bg-gradient-to-br from-emerald-300 to-teal-500 text-emerald-950 text-[11px] font-bold uppercase tracking-widest px-2.5 py-1 shadow-sm ${className}`}
    >
      <Lightbulb size={12} strokeWidth={2.4} /> Innovator
    </span>
  );
}
